<template>
<b-button @click="click"
          v-if="toolboxButton.visible &&  (!toolboxButton.requiredPermission || permissions[toolboxButton.requiredPermission])"
          :disabled="toolboxButton.disabled"
          :title="toolboxButton.label"
          :data-test-path="toolboxButton.dataTestPath"
          @keydown="onKeyDown"
          @focusout="focusout"
          :class="toolboxButton.customClass"
          :style="toolboxButton.customClass ? '': 'width: 42px'"
          :variant="toolboxButton.type === 'toggle' ? (toggled ? 'plm-toolbar-selected':'plm-toolbar-secondary') : toolboxButton.variant">
    <font-awesome-icon v-if="!toolboxButton.noIcon" :icon="toolboxButton.icon" :transform="toolboxButton.iconTransform"></font-awesome-icon>
    <span class="no-text" v-if="toolboxButton.text">{{toolboxButton.text}}</span>
    </b-button>
</template>

<script>
import PermissionsSet from "@/server/PermissionsSet";

export default {
  name: "SideMenuButton",
  props: {
    toolboxButton: {default: null},
    icon: {type:String, default:"print"},
  },
  data:function() { return {
    permissions: new PermissionsSet(),
    toggled:this.toolboxButton.toggled
  }},

  model:{
    prop: 'toggledInitial',
    event: 'toggled-change'
  },

  methods:{
    focusout(data){
      this.$emit('focusout', data);
    },
    click(){
      if(this.toolboxButton.type !== 'toggle') {
        this.$emit('executed');
        this.toolboxButton.action(this.toolboxButton);
        return;
      }

      //This event is emitted to prevent default column sorting on RevoGrid
      // if(this.toolboxButton.label === 'Edit') {
      //   EventBus.$emit(Events.keepDefaultSorting);
      // }

      this.toggled = !this.toggled;

      this.$emit('toggled-change', this.toggled);

      if(!this.toggled){
        this.$emit('toggled-off');
      } else {
        this.$emit('toggled-on');
      }

      this.$emit('executed');
      this.toolboxButton.execute(this.toolboxButton);
      this.toolboxButton.toggle(this.toggled);

    },
    onKeyDown(ev){
      let key = ev.keyCode || ev.charCode;

      if( key == 27 ) {
        this.$emit('escape');
      }
    },
  }
}
</script>

<style scoped>
@media screen and (max-width: 990px){
  .no-text {
    display: none;
  }
}
</style>